export const mutations = {
    setPerfil(state, perfil) {
        state.perfil = perfil
    },
    setPerfis(state, perfis) {
        state.perfis = perfis
    },
    setPerfilPermissoesSelecionadas(state, data){
        state.perfilPermissoesSelecionadas = data
    },
    addPermissaoSelecionada(state, data) {
        state.perfilPermissoesSelecionadas.push(data)
    },
    addPerfil(state, data){
        state.perfis.push(data)
    },
    removePerfil(state, data){
        let index = state.perfis.map(x => x.id).indexOf(data.id);
        state.perfis.splice(index, 1)
    },
    setModalCadastrarPerfil(state, status) {
        state.modalCadastrarPerfil = status
    },
    setModalExcluirPerfil(state, status) {
        state.modalExcluirPerfil = status
    },
    setModalPesquisarPerfil(state, status) {
        state.modalPesquisarPerfil = status
    }
}

export default {}